import {request} from '@umijs/max';

export async function findAppVersion(params = {}) {
  return request('/api/appVersion/find', {
    params,
  });
}

export async function createOrUpdate(params = {}) {
  return request('/api/appVersion/saveOrUpdate', {
    method: 'post',
    data: params,
  });
}
